import React from "react";
import ReportOption from "../ReportOption";
import { CONSTANTS } from "../../utils";
import Fab from "@material-ui/core/Fab";

function ReportButtons(props) {
  const disableReport = props.disabled
  return (
    <div>
      <div>
        <ReportOption
          text="מלוכלך וגדול עלי לנקות"
          score={CONSTANTS.REPORTER_SCORE.DID_NOT_CLEAN}
          setReportScore={function () {
            props.setReportScore(
              CONSTANTS.REPORT_SCORE.DIRTY,
              CONSTANTS.REPORTER_SCORE.DID_NOT_CLEAN
            );
          }}
        />
        <ReportOption
          text="לקחתי את הזבל שלי מהשטח"
          score={CONSTANTS.REPORTER_SCORE.CLEANED_A_LITTLE}
          setReportScore={function () {
            props.setReportScore(
              CONSTANTS.REPORT_SCORE.PRETTY_DIRTY,
              CONSTANTS.REPORTER_SCORE.CLEANED_A_LITTLE
            );
          }}
        />
        <ReportOption
          text="ניקיתי ופיניתי קצת"
          score={CONSTANTS.REPORTER_SCORE.CLEANED_A_LITTLE}
          setReportScore={function () {
            props.setReportScore(
              CONSTANTS.REPORT_SCORE.PRETTY_CLEAN,
              CONSTANTS.REPORTER_SCORE.CLEANED_A_LITTLE
            );
          }}
        />
        <ReportOption
          text="ניקיתי, פיניתי ועכשיו מצוחצח"
          score={CONSTANTS.REPORTER_SCORE.CLEANED}
          setReportScore={function () {
            props.setReportScore(
              CONSTANTS.REPORT_SCORE.CLEAN,
              CONSTANTS.REPORTER_SCORE.CLEANED
            );
          }}
        />
      </div>
      <Fab
        style={{ marginTop: "1rem", width: "30%", fontSize: "1.4rem" }}
        variant="extended"
        onClick={props.report.bind(this)}
        aria-label="like"
        disableFocusRipple={true}
        disabled={disableReport}
        disableRipple={true}
      >
        דווח
      </Fab>
    </div>
  );
}

export default ReportButtons;
